import { CalculateFestivalEss } from '@/domain/impact-calculate-festival/entities/calculate-festival-ess.entity';
import { selectCurrentProjectFestival } from '@/domain/project-festival/project-festival.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  projectId: number;
};

type Result = {
  ess: CalculateFestivalEss;
};

export const runImpactCalculateFestivalEssForProject = createAppAsyncThunk(
  'impactCalculateFestival/runImpactCalculateFestivalEssForProject',
  async (
    params: Params,
    { extra: { impactCalculateFestivalGateway, snackbarGateway }, getState },
  ): Promise<Result> => {
    try {
      const currentProject = selectCurrentProjectFestival(getState());
      const modelVersion = currentProject?.models?.ess || '';
      const calculateEss =
        await impactCalculateFestivalGateway.runImpactCalculateFestivalEssForProject(
          params.projectId,
          modelVersion,
        );
      return { ess: calculateEss };
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
